(() => {
  const cookieButton = document.querySelector('[data-d2f-cookie-settings]');
  cookieButton?.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    const trigger = document.querySelector('#CookiebotWidget button.CookiebotWidget-logo');
    if (trigger) trigger.click();
    else if (window.Cookiebot) window.Cookiebot.show();
  });
  const dock = document.querySelector('[data-d2f-google-quality]');
  if (!dock) return;
  const googleScript = document.createElement('script');
  googleScript.src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
  googleScript.async = true;
  googleScript.addEventListener('load', () => window.merchantwidget.start({ position: 'RIGHT_BOTTOM', region: 'GB', merchant_id: 113821329 }));
  document.head.appendChild(googleScript);
  const attach = () => {
    const widget = document.getElementById('google-merchantwidget-iframe-wrapper');
    if (!widget) return false;
    widget.classList.add('d2f-footer-google-widget');
    let promotionChecked = false;
    const setStyle = (element, key, value) => {
      if (element.style.getPropertyValue(key) !== value) element.style.setProperty(key, value, ['bottom', 'right'].includes(key) ? 'important' : '');
    };
    const sync = () => {
      const width = parseFloat(widget.style.width) || 0;
      const height = parseFloat(widget.style.height) || 0;
      const ready = !widget.hidden && width > 0 && height > 0;
      const expanded = height > 180;
      widget.classList.toggle('d2f-google-expanded', expanded);
      setStyle(widget, 'bottom', expanded ? '16px' : '136px');
      setStyle(widget, 'right', '16px');
      dock.classList.toggle('d2f-google-ready', ready);
      if (ready && !expanded) {
        setStyle(dock, '--d2f-google-width', `${width}px`);
        setStyle(dock, 'min-height', `${height}px`);
        const rect = dock.getBoundingClientRect();
        setStyle(widget, '--d2f-google-left', `${rect.left + window.scrollX}px`);
        setStyle(widget, '--d2f-google-top', `${rect.top + window.scrollY}px`);
      }
      if (ready && !promotionChecked) {
        promotionChecked = true;
        if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(window.location.pathname)) {
          try {
            const previous = Number(sessionStorage.getItem('d2f_google_quality_notice') || 0);
            if (!previous || Date.now() - previous > 30 * 60 * 1000) {
              sessionStorage.setItem('d2f_google_quality_notice', String(Date.now()));
              widget.classList.add('d2f-google-promoting');
              window.setTimeout(() => widget.classList.remove('d2f-google-promoting'), 5000);
            }
          } catch (_) {}
        }
      }
    };
    new MutationObserver(sync).observe(widget, { attributes: true, attributeFilter: ['style', 'hidden'] });
    window.addEventListener('resize', sync);
    window.addEventListener('load', sync, { once: true });
    new ResizeObserver(sync).observe(document.querySelector('footer'));
    sync();
    return true;
  };
  if (!attach()) {
    const observer = new MutationObserver(() => {
      if (attach()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true });
  }
})();
